export default __webpack_public_path__ + "assets/images/067da76bba02f1852294b689212ba93a.svg";